"use strict";

require("core-js/modules/es.symbol.description");

const SymbolStop = Symbol.for('stop');
module.exports = isStop;

function isStop(a) {
  return !!(a && a[SymbolStop]);
}